<template>
  <div class="modal" @click.self="closePopup">
    <div class="modal-dialog thanks-dialog">
      <div class="modal-title thanks-title">Thank you for installing</div>
      <div class="modal-content">
        <div class="thanks-content">
          <div>
            <img src="../assets/img/thanks.svg" alt="image">
          </div>
          <div>
            <p>Never miss a deal again with Cashback Alert</p>
            <p>You can find us in <a href="https://play.google.com/store/apps/details?id=com.buntai.cashbackalert" class="thanks-link">Android store</a> also</p>
          </div>
        </div>
        <div class="text-center">
          <button class="btn-main thanks-btn" @click="closePopup">Got It &nbsp;
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 9.50021H16M16 9.50021L7.29028 0.790527M16 9.50021L7.29028 18.2099" stroke="white" stroke-width="2"/>
          </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  name: 'Thanks',
  methods: {
    closePopup (){
      this.$emit('closethanks')
    },
  }
}
</script>

<style lang="scss">

.thanks {
  &-title.modal-title {
    font-size: 32px;
    text-align: center;
    justify-content: center;
    font-weight: 700;
    padding: 40px 40px 0;
  }
  &-content {
    font-size: 16px;
    line-height: 1.4;
    display: flex;
    align-items: center;

    & > div {
      padding: 0 20px 20px;
      width: 50%;
    }
  }

  &-dialog .modal-content {
    padding: 40px;
  }
}

.thanks-link {
  font-weight: 700;
  color: #4b2eff;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
}

.btn-main.thanks-btn {
  padding: 20px 60px;
  font-size: 18px;
  text-transform: uppercase;

  svg {
    vertical-align: middle;
  }
}

@media screen and (max-width: 500px){
  .thanks-content {
    flex-direction: column;

    & > div {
      width: 100%;
      padding: 5px;
      text-align: center;
    }
  }
}

</style>
